<div class="app-titulo-pagina">
  <span>Vales Presentes</span>
</div>
<a (click)="router.navigate(['/valepresente/parceiros'])" id="btn-vale-cesta" class="btn app-btn-best">
  <i class="fa fa-gift"></i> Adicionar Vales à Cesta
</a>
<br />

<div *ngIf="processando" class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<br>

<div *ngIf="!processando && itens.length > 0">
  <div style="padding: 0.5em;">
    CONFIRA TODAS AS INFORMAÇÕES DO SEU PEDIDO DE VALE PRESENTE,
    FRETE E LOCAL DE ENTREGA ANTES DE FINALIZAR O RESGATE.
  </div>
  <br>
  <div class="container">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Parceiro</th>
            <th>Valor unitário</th>
            <th>Tipo do Vale</th>
            <th>Quantidade</th>
            <th>Valor total</th>
            <th>Pontos totais</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itens" [ngClass]="{'danger': item.isInvalid}">
            <td>{{ item.valePresente.parceiro.nome }}</td>
            <td>R$ {{ item.valor | number:'1.2-2' }}</td>
            <td>{{ item.valePresente.virtual ? 'Virtual' : 'Físico' }}</td>
            <td>{{ item.quantidade }}</td>
            <td>R$ {{ item.valorTotal() | number:'1.2-2' }}</td>
            <td>{{ item.pontosTotais() }}</td>
            <td>
              <button type="button" *ngIf="item.isInvalid" (click)="showItemError(item)" id="btn-warning"
                class="btn btn-warning">
                <i class="fa fa-warning" aria-hidden="true"></i> erro
              </button>

              <button type="button" id="btn-remover" (click)="remove(item.valePresente)" class="btn app-btn-best">
                <i class="fa fa-times" aria-hidden="true"></i> remover
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot style="border-top: 1px solid #dddddd">
          <th style="padding: 8px">TOTAL</th>
          <th style="padding: 8px"></th>
          <th style="padding: 8px"></th>
          <th style="padding: 8px">{{ totalItens }}</th>
          <th style="padding: 8px">R$ {{ valorTotal| number:'1.2-2' }}</th>
          <th style="padding: 8px">{{ pontosTotais}}</th>
          <th style="padding: 8px"></th>
        </tfoot>
      </table>
    </div>

    <button (click)="validarCesta()" *ngIf="!mainService.valePresenteCestaService.isValid() && !processando"
      style="margin-top: 1em;" id="btn-concluir-resgate" class="btn app-btn-best">
      Concluir Resgate
    </button>

    <div *ngIf="mainService.valePresenteCestaService.isValid() && !processando">
      <hr>
      <div *ngIf="!mainService.sessionService.clienteValePresenteFreteGratuito && pedidoComValeFisico">
        <h2 class="hidden-xs">Endereço de entrega</h2>
        <h4 class="visible-xs">Endereço de entrega</h4>

        <div *ngIf="processandoCalcularFrete" class="text-center">
          <i class="fa fa-spinner fa-pulse fa-4x"></i>
        </div>

        <div class="form-group col-xs-12 col-md-4 col-md-offset-4 {{ cep.length === 8 ? '' : 'has-error' }}"
          *ngIf="itens.length && !processandoCalcularFrete">

          <div class="input-group">
            <span class="input-group-addon">CEP:</span>
            <input type="text" id="cep" [(ngModel)]="cep" (ngModelChange)="clean()" placeholder="00000000"
              class="form-control input-sm" uiCep uiEnter="btn-calcular-frete" required>
            <span class="input-group-btn">

              <button type="button" id="btn-calcular-frete" class="btn app-btn-best btn-sm" (click)="calcularFrete()">
                Calcular frete
              </button>
            </span>
          </div>

        </div>

        <div class="form-group col-xs-12" *ngIf="fretes">
          <div class="radio" *ngFor="let frete of fretes">
            <span>
              <label for="{{ frete.tipo }}">
                <input type="radio" name="frete" id="{{ frete.tipo }}" [value]="frete.frete"
                  (change)="setEndereco(frete.frete)" required>
                {{ frete.tipo }} por {{ frete.frete.pontos }} pontos.
              </label>
            </span><br>
          </div>
          <hr>

        </div>

      </div>

      <div *ngIf="mainService.sessionService.clienteValePresenteFreteGratuito" style="margin-bottom: 1em;">
        Frete Gratuito
      </div>

    </div>

    <div
      *ngIf="pedido.frete !== undefined && pedido.frete.pontos !== undefined && !mainService.valePresenteCestaService.hasError"
      class="col-xs-12">
      {{ 'Confira as informações abaixo e conclua o resgate.'|uppercase }}
      <br><br>

      <div class="app-vale-presente-bordas">
        <div *ngIf="!mainService.sessionService.clienteValePresenteFreteGratuito && pedidoComValeFisico"
          class="col-xs-12 col-md-6 app-borda-divisora">
          <div class="form-group col-xs-12">
            <label for="destinatario">Nome do Destinatário</label>
            <input type="text" id="destinatario" name="destinatario" [(ngModel)]="pedido.destinatario"
              class="form-control input-sm" placeholder="Digite o seu nome ou de quem receberá o vale" required>
          </div>
          <div class="form-group col-xs-12">
            <label for="logradouro">Logradouro</label>
            <input type="text" id="logradouro" name="logradouro" [(ngModel)]="pedido.endereco.logradouro"
              [readonly]="logradouroIsReadOnly" class="form-control input-sm" readonly>
          </div>
          <div class="form-group col-xs-4 col-md-4">
            <label for="numero">Número</label>
            <input type="text" id="numero" nome="numero" [(ngModel)]="pedido.endereco.numero"
              class="form-control input-sm" maxlength="64">
          </div>
          <div class="form-group col-xs-8 col-md-8">
            <label for="complemento">Complemento</label>
            <input type="text" id="complemento" name="complemento" [(ngModel)]="pedido.endereco.complemento"
              class="form-control input-sm" maxlength="256">
          </div>
          <div class="form-group col-xs-12 col-md-5">
            <label for="bairro">Bairro</label>
            <input type="text" id="bairro" nome="bairro" [(ngModel)]="pedido.endereco.bairro"
              [readonly]="bairroIsReadOnly" class="form-control input-sm" readonly>
          </div>
          <div class="form-group col-xs-8 col-md-5">
            <label for="cidade">Cidade</label>
            <input type="text" id="cidade" name="cidade" [(ngModel)]="pedido.endereco.cidade"
              class="form-control input-sm" readonly>
          </div>
          <div class="form-group col-xs-4 col-md-2">
            <label for="uf">UF</label>
            <input type="text" id="uf" name="uf" [(ngModel)]="pedido.endereco.uf" class="form-control input-sm"
              readonly>
          </div>
        </div>

        <div
          [ngClass]="{'col-md-offset-3' : mainService.sessionService.clienteValePresenteFreteGratuito || !pedidoComValeFisico}"
          class="col-xs-12 col-md-6">
          <div class="form-group col-xs-12">
            <label for="pontosTotais">Total de vales presentes em pontos</label>
            <input type="text" id="pontosTotais" [value]="pontosTotais" class="form-control input-sm" readonly>
          </div>
          <div class="form-group col-xs-12">
            <label for="fretePontos">Frete em pontos</label>
            <input type="text" id="fretePontos" [value]="pedido.frete.pontos" class="form-control input-sm" readonly>
          </div>
          <div class="form-group col-xs-12">
            <label for="totalPontos">Total em pontos</label>
            <input type="text" id="totalPontos" [value]="pontosTotais + pedido.frete.pontos"
              class="form-control input-sm" readonly>
          </div>
          <div class="form-group col-xs-12">
            <label for="ep">Senha eletrônica </label>
            <input type="password" id="ep" class="form-control input-sm" [(ngModel)]="ep">
          </div>
          <button class="btn btn-success-v2" *ngIf="!processando" id="btn-concluir" (click)="save()">
            Concluir
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!itens.length" class="col-xs-12 text-center">
  Sua cesta está vazia! Clique em Adicionar para escolher um novo Vale Presente.
</div>
<div class="clearfix"></div>


// WEBPACK FOOTER //
// ./src/app/vale-presente/cesta/cesta.component.html